module.exports = __webpack_public_path__ + "static/img/27-1.8a30c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/27-1.jpg
// module id = rMSv
// module chunks = 0